import type { HelpFile } from '../../types/help'
import { ProvisioningHistoryTestIds } from '../../../testids/ProvisioningHistoryTestIds'

export const provisioningHistoryHelp: HelpFile = {
  docPage: '/docs/provisioning/provisioning-history',
  texts: {
    [ProvisioningHistoryTestIds.provisioningHistoryPage]: 'Historical record of completed, failed, and skipped Provisioning Tasks.',
    [ProvisioningHistoryTestIds.btnRefresh]: null,
    [ProvisioningHistoryTestIds.colAction]: 'Provisioning action — grant, revoke, or update.',
    [ProvisioningHistoryTestIds.colCompletedAt]: 'When the Provisioning Task finished, regardless of outcome.',
    [ProvisioningHistoryTestIds.colCreatedAt]: null,
    [ProvisioningHistoryTestIds.colEntitlement]: 'Enforcement Object provisioned, removed, or updated by this task.',
    [ProvisioningHistoryTestIds.colIdentity]: null,
    [ProvisioningHistoryTestIds.colRetries]: 'Number of retries after transient failures.',
    [ProvisioningHistoryTestIds.colStatus]: null,
    [ProvisioningHistoryTestIds.colTargetSystem]: null,
    [ProvisioningHistoryTestIds.historyMinQHint]: null,
    [ProvisioningHistoryTestIds.historySearchScopeHint]: null,
  },
}
